"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.convertActionToBase64 = function (action) {
  return Buffer.from(JSON.stringify(action)).toString('base64');
};

exports.createCache = function (isCacheable, isValid) {
  var items = {};

  var add = function add(action, value) {
    if (isCacheable(action)) {
      items[exports.convertActionToBase64(action)] = __assign({}, value, {
        timestamp: Date.now()
      });
    }
  };

  var remove = function remove(action) {
    delete items[exports.convertActionToBase64(action)];
  };

  var get = function get(action) {
    var response = items[exports.convertActionToBase64(action)];
    var valid = response && isValid(response);

    if (valid) {
      return response;
    }

    if (response && !valid) {
      remove(action);
    }
  };

  var setItems = function setItems(value) {
    items = value;
  };

  var getItems = function getItems() {
    return items;
  };

  return {
    add: add,
    get: get,
    getItems: getItems,
    remove: remove,
    setItems: setItems
  };
};